/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import AttachEmailTwoToneIcon from '@mui/icons-material/AttachEmailTwoTone';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import { Autocomplete, Box, Button, Card, CardContent, FormControl, InputAdornment, InputLabel, MenuItem, Modal, Select, TextField, Tooltip, Typography } from "@mui/material";
import Grid from "@mui/material/Grid";
import TimelineItem from "components/Icon/TimelineItem";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { useCallback, useEffect, useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { appConstants } from "utils/appConstants";
import { GridSearchIcon } from "@mui/x-data-grid";
import { BTable } from "components/BTable/BTable";
import { getColorMappings } from "components/ColorComponent/ColorComponent";
import PickDate from "components/DatePicker/DatePicker";
import { useSearchParams } from 'react-router-dom';
import { loadingAction } from "ReduxReducers/loadingReducer";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import DeleteModal from "components/deletemodal/deletemodal";
import { useMaterialUIController } from "context";
import PageTitle from "examples/PageTitle/PageTitle";
import { createTheme } from "react-data-table-component";
import { useDispatch, useSelector } from "react-redux";
import 'react-toastify/dist/ReactToastify.css';
import Swal from 'sweetalert2';
import { fetchInvoicePdfTheme } from "utils/api";
import { MergeContactTransaction, deleteContactRecords, getAllContactsList, getBusinessUserContacts, getCustomerActivityStatements } from "utils/contactAPI";
import { generateDataList, getDownloadFileName, getScreenRight, showResMsg } from "utils/generic";
import { genericMessage } from 'utils/genericMessages';
import EditIcon from '@mui/icons-material/Edit';
import MergeTypeIcon from '@mui/icons-material/MergeType';
import DeleteIcon from '@mui/icons-material/Delete';
import IconMenu from "components/CustomMaterialMenu/Custom";
import ShowSwalWithButtons from 'components/SwalAlert/swalPopupWithButtons';
import SearchField from 'components/SearchField/SearchField';
import { formatCurrencyAUD } from 'utils/formatCurrency';

const SCREEN_NAME = "Contacts";
let SCREEN_RIGHT;

const mergeModalstyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 600,
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
  display: 'grid',
  justifyContent: 'center'
};

createTheme(
  'solarized',
  {
    text: {
      primary: 'white',
      secondary: 'white',
    },
    background: {
      default: '#202940',
    },
    context: {
      background: '#202940',
      text: 'white',
    },
    divider: {
      default: 'white',
    },
    //   button: {
    //     default: '#2aa198',
    //    hover: 'rgba(0,0,0,.08)',
    //    focus: 'rgba(255,255,255,.12)',
    //  disabled: 'rgba(255, 255, 255, .34)',
    // },
    sortFocus: {
      default: '#2aa198',
    },
  },
  'dark',
);
createTheme(
  'light',
  {
    text: {
      primary: 'black',
      secondary: 'black',
    },
    background: {
      default: 'white',
    },
    context: {
      background: 'white',
      text: 'black',
    },
    divider: {
      default: 'gray',
    },
    sortFocus: {
      default: '#2aa198',
    },
  },
  'dark',
);
let ContactType = undefined;
let contactStatus = undefined;
function Contacts() {
  let currency = useSelector((state) => state.currency.currencySymbol);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [deleteDialogeFlag, setDeleteDialogeFlag] = useState(false);
  const [deleteHeading, setDeleteHeading] = useState("");
  const [showSelectedContactName, setSelectedContactName] = useState("");
  const [rows, setRows] = useState([]);
  const [searchParams, setSearchParams] = useSearchParams();
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(20);
  const [controller] = useMaterialUIController();
  const { sidenavColor, darkMode } = controller;
  const { barColor } = getColorMappings(sidenavColor);
  const [showMergeModal, setShowMergeModal] = useState(false);
  const [loginDetails, setLoginDetails] = useState(JSON.parse(sessionStorage.getItem("LOGIN_DETAILS")));
  const [token, setToken] = useState(sessionStorage.getItem("TOKEN"));
  const [screenAccess, setScreenAccess] = useState(false);

  const [showStatementModal, setShowStatementModal] = useState(false);

  const [values, setValues] = useState({
    _id: [],
    duration: "lastMonth",
    sortingType: "",
    sortingField: "",
    contactStatus: "All",
    contactType: "All",
    durationDate: "",
    fromDate: "",
    toDate: "",
    page: appConstants.page,
    limit: appConstants.limit,
    filterValues: "",
    theyOwe: "",
    searchParameterList: ['name', 'streetAddress', 'emailAddress', 'finalAmount', 'youOwe', 'theyOwe', 'contactType', 'companyName'],
    businessUserID: JSON.parse(sessionStorage.getItem("LOGIN_DETAILS"))?.businessUserID,
    token: token,
    themeID: ""
  });

  const [themeName, setThemeName] = useState([]);
  const [contactForMerge, setContactForMerge] = useState([]);


  // const [customerStatement, setcustomerStatement] = useState({
  //   businessUserID: JSON.parse(sessionStorage.getItem("LOGIN_DETAILS"))?.businessUserID,
  //   dashboardDuration: "custom",
  //   customFrom: new Date(new Date().setDate(new Date().getDate() - 1)),
  //   customTo: new Date(),
  // });




  const [mergeContactValues, setMergeContactValues] = useState({
    businessUserID: JSON.parse(sessionStorage.getItem("LOGIN_DETAILS"))?.businessUserID,
    contactType: "",
    merge_ID: "", merge_Contact: "",
    mergeWith_ID: "", mergeWith_ContactName: ""
  });
  const [customerContact, setCustomerContatList] = useState(null);
  const [toggleCleared, setToggleCleared] = useState(false);
  const getFromToDate = (type) => {
    const currentDate = new Date();
    if (type === "from") {
      return new Date(currentDate.getFullYear(), currentDate.getMonth() - 1);
    }
    else if (type === "to") {
      return new Date(currentDate.getFullYear(), currentDate.getMonth(), 0);
    }
  }
  const [statementsValues, setStatementValues] = useState({
    businessUserID: JSON.parse(sessionStorage.getItem("LOGIN_DETAILS"))?.businessUserID,
    contactIDs: [],
    // from: new Date(new Date().setDate(new Date().getDate() - 1)),
    // to: new Date(),
    from: getFromToDate("from"),
    to: getFromToDate("to"),
  });

  const [showStatementBtn, setShowStatementBtn] = useState(false);

  const handleDateChange = (name) => (date) => {
    setValues({ ...values, [name]: new Date(date) });

  };
  // const handleDateChange = (name) => (date) => {
  //   setStatementValues({ ...statementsValues, [name]: new Date(date) });

  // };


  useEffect(() => {
    var element = document.getElementsByTagName('fieldset');
    let labelShrink = document.getElementsByClassName("MuiInputLabel-outlined");
    var dropicons = document.querySelectorAll('.MuiInputBase-root');
    for (let i = 0; i < element.length; i++) {

      element[i].style.borderColor = darkMode ? "white" : tableBorder;
    }

    for (let i = 0; i < labelShrink.length; i++) {
      labelShrink[i].style.color = darkMode ? "white" : tableBorder;;
    }

    for (let i = 0; i < dropicons.length; i++) {
      var svgicon = dropicons[i].getElementsByTagName('svg');
      if (svgicon.length > 0) {
        if (darkMode) {
          svgicon[0].setAttribute("style", "fill: white !important;");
        } else {
          svgicon[0].setAttribute("style", "fill:");
        }
      }
    }
  }, [showStatementBtn])







  useEffect(() => {
    const fetchData = async () => {
      try {
        let Type = ContactType || new URLSearchParams(window.location.search).get('ctype');
        // setShowStatementBtn(Type === "Customer" || Type === "Supplier");
        const isCustomerType = Type === "Customer";
        if (Type) {
          values.contactType = Type;

        }
        let sType = contactStatus || new URLSearchParams(window.location.search).get('contactStatus');
        if (sType) {
          values.contactStatus = sType;
        }
        let duration = new URLSearchParams(window.location.search).get('duration');
        let customFrom = new URLSearchParams(window.location.search).get('from');
        let customTo = new URLSearchParams(window.location.search).get('to');
        duration && (values.durationDate = duration)
        customFrom && (values.fromDate = customFrom)
        customTo && (values.toDate = customTo)
        setLoginDetails(JSON.parse(sessionStorage.getItem("LOGIN_DETAILS")));
        await getRight();
        await allContactForMerge();
        await fetchContacts();

      } catch (error) {
        console.error("Error in useEffect:", error.message);
      }
    };
    fetchData();
  }, [values.contactStatus, values.contactType, values.sortingType, perPage]);


  async function getRight() {
    SCREEN_RIGHT = await getScreenRight(SCREEN_NAME);
    // setScreenAccess(SCREEN_RIGHT === 'Full Access');
    if (SCREEN_RIGHT === "Full Access") {
      setScreenAccess(true)
    }
    else {
      setScreenAccess(false)
    }
  }
  const allContactForMerge = async () => {
    getAllContactsList(values, async (data) => {
      let resData = data.Result_Output;
      if (resData) {
        setCustomerContatList(resData);
      }
    }, dispatch);
  }
  const fetchContacts = async () => {
    let Type = new URLSearchParams(window.location.search).get('customertype');
    setShowStatementBtn(Type);
    console.log("dfd", setShowStatementBtn(Type))
    values.perPage = perPage;
    if (Type) {
      values.Type = Type; // Add 'Type' to the request payload
    }
    getBusinessUserContacts(values, async (data) => {
      let resData = data.Result_Output;
      console.log("resData33", resData);
      // let Type = new URLSearchParams(window.location.search).get('ctype');

      // if (Type) {
      //   if (resData) {
      //     let filtered = resData.docs;
      //     let filteredRows = filtered.filter(contact => contact.theyOwe > 1);
      //     console.log("filteredRows", filteredRows);
      //     setRows(filteredRows);
      //     setTotalRows(filteredRows.length);
      //   } else {
      //     console.error("Expected resData to be an array but got:", typeof resData);
      //   }
      // } else {
      //   if (resData && resData.docs) {
      //     setRows(resData.docs);
      //     setTotalRows(resData.totalDocs);
      //     await fetchInvoicePdfName();
      //   } else {
      //     console.error("Expected resData.docs and resData.totalDocs to exist, but they don't.");
      //   }
      // }
      setRows(resData.docs);
      setTotalRows(resData.totalDocs);
      await fetchInvoicePdfName();
    }, dispatch);

  }
  const fetchInvoicePdfName = async () => {
    fetchInvoicePdfTheme(values, async (data) => {
      if (data.Result_Output.length > 0) {
        values.themeID = data.Result_Output[0]._id;
        setThemeName(await generateDataList(data.Result_Output, "_id", "themeName"));
      }
    }, dispatch);
  };
  const handleAutoComplete = (name) => (event, newValue) => {
    if (newValue) {
      setMergeContactValues({ ...mergeContactValues, [name]: newValue.label, mergeWith_ID: newValue.id });
    } else {
      setMergeContactValues({ ...mergeContactValues, [name]: '', mergeWith_ID: '' });
    }
  };

  const handleDeleteDialogeClick = async (value) => {
    values._id.push(value);
    setDeleteDialogeFlag(!deleteDialogeFlag);
  };

  const handleCancel = (name) => (event) => {
    values._id = [];
    setDeleteDialogeFlag(false);
  };

  const handleDelete = async (id) => {
    deleteContact();
    setDeleteDialogeFlag(!deleteDialogeFlag);
  };

  const deleteContact = async () => {
    dispatch(loadingAction(true));
    try {

      deleteContactRecords(values, (data) => {
        setValues({ ...values, _id: [] });
        showResMsg(data.Result_Status ? genericMessage.deleted : data.Result_Message, 1000, data.Result_Status);
        fetchContacts();
      }, dispatch)
    } catch (error) {
      console.log("Catch in deleteContact API=", error);
    }
    dispatch(loadingAction(false));
  };

  const getSentDate = useCallback((values) => {
    let startDate, endDate;

    if (values.duration === "custom") {
      startDate = new Date(values.fromDate);
      startDate.setUTCHours(0, 0, 0, 0);
      endDate = new Date(values.toDate);
      endDate.setUTCHours(23, 59, 59, 999);

    } else {
      const today = new Date();
      today.setUTCHours(0, 0, 0, 0);

      if (values.duration === "today") {
        startDate = new Date(today);
        endDate = new Date(today);
        endDate.setUTCHours(23, 59, 59, 999);

      } else if (values.duration === "lastWeek") {
        startDate = new Date(today);
        startDate.setDate(today.getDate() - 7);
        endDate = new Date(today);
        endDate.setUTCHours(23, 59, 59, 999);

      } else if (values.duration === "lastMonth") {
        startDate = new Date(today);
        startDate.setMonth(today.getMonth() - 1);
        endDate = new Date(today);
        endDate.setUTCHours(23, 59, 59, 999);

      } else if (values.duration === "lastYear") {
        startDate = new Date(today);
        startDate.setFullYear(today.getFullYear() - 1);
        endDate = new Date(today);
        endDate.setUTCHours(23, 59, 59, 999);
      }
    }
    return { startDate, endDate };
  }, [values.duration, values.fromDate, values.toDate]);



  // console.log("startDate", startDate)
  // console.log("startDate", endDate)
  // const formatDate = useCallback((date) => {
  //   console.log("render formatate");
  //   const year = date.getUTCFullYear();
  //   const month = String(date.getUTCMonth() + 1).padStart(2, '0');
  //   const day = String(date.getUTCDate()).padStart(2, '0');
  //   return `${year}-${month}-${day}`;
  // }, []);

  // const formattedStartDate = useMemo(() => startDate ? formatDate(startDate) : '', [startDate, formatDate]);
  // const formattedEndDate = useMemo(() => endDate ? formatDate(endDate) : '', [endDate, formatDate]);

  // console.log("formattedStartDate", formattedStartDate)
  // console.log("formattedEndDate", formattedEndDate)
  const handleCustomerStatement = () => {
    setShowStatementModal(true);
  };

  const handleCloseModel = () => {
    setShowStatementModal(false);
  };

  const handleSearchFilter = (event) => {
    setValues({ ...values, filterValues: event.target.value });
  };

  const handleSort = async (type, value) => {
    values.sortingType = value;
    values.sortingField = type;
  };

  const handlePageChange = page => {
    values.page = page;
    // setShowStatementBtn(showStatementBtn);
    fetchContacts();
  };

  const handlePerRowsChange = async (newPerPage, page) => {

    dispatch(loadingAction(true));
    values.page = page;
    values.limit = newPerPage;
    setPerPage(newPerPage);
    dispatch(loadingAction(false));
  };

  const handleRowSelected = ({ selectedRows }) => {
    setShowStatementBtn(selectedRows.length > 0)
    setStatementValues({ ...statementsValues, contactIDs: selectedRows.map(row => row._id) });
  }

  const rowDisabledCriteria = (row) => row.contactType === "Supplier" || row.finalAmount === 0;


  let columns = [
    {
      // name: "Full Name",
      name: <p style={{ fontSize: '12px' }}>Company Name</p>,
      // selector: row => row.name,
      selector: row => (
        <span style={{ fontSize: "12px" }}>{row.companyName}</span>
      ),
      cell: row => (
        <div
          // style={{
          //   color: (row.contactType === "Customer" && row.finalAmount > 0) ? 'green' : '',
          // }}
          style={{
            color: (row.contactType === "Customer" && row.finalAmount > 0)
              ? (darkMode ? 'white' : 'green')
              : ''
          }}

        >
          {row.companyName}
        </div>
      ),
      sortable: true,
      sortField: 'name',
    },
    {
      // name: "Contact Type",
      name: <p style={{ paddingLeft: "15px", fontSize: '12px' }}>Contact Type</p>,
      // selector: row => row.contactType,
      selector: row => (
        <span style={{ fontSize: "12px" }}>{row.contactType}</span>
      ),
      sortable: true,
      sortField: 'contactType',
      style: { paddingLeft: "10px" },
      center: "true",

    },
    {
      // name: "Email Address",
      name: <p style={{ paddingLeft: "12px", fontSize: '12px' }}>Email Address</p>,
      // selector: row => row.emailAddress,
      selector: row => (
        <span style={{ fontSize: "12px" }}>{row.emailAddress}</span>
      ),
      sortable: true,
      sortField: 'emailAddress',
      minWidth: "220px !important",
      style: { paddingLeft: "10px" },
    },
    {
      // name: "Address",
      name: <p style={{ paddingLeft: "12px", fontSize: '12px' }}>Address</p>,
      selector: row => (
        <Tooltip title={row.streetAddress} arrow>
          <span style={{ fontSize: '12px' }}>{row.streetAddress}</span>
        </Tooltip>),
      sortable: true,
      sortField: 'streetAddress',
      minWidth: "250px !important",
      center: "true",
    },
    {
      // name: `They owe (${currency})`,
      name: <p style={{ paddingLeft: "22px", fontSize: "12px" }}>{`They owe (${currency})`}</p>,
      // selector: row => row.theyOwe || "",
      selector: row => (
        <span style={{ fontSize: "12px" }}>{formatCurrencyAUD(row.theyOwe) || ""}</span>
      ),
      sortable: true,
      sortField: 'theyOwe',
      center: "true",
    },
    {
      // name: `You owe (${currency})`,
      name: <p style={{ paddingLeft: "25px", fontSize: "12px" }}>{`You owe  (${currency})`}</p>,
      // selector: row => row.youOwe || "",
      selector: row => (
        <span style={{ fontSize: "12px" }}>{formatCurrencyAUD(row.youOwe) || ""}</span>
      ),
      sortable: true,
      sortField: 'youOwe',
      center: "true",
    },
    {
      // name: `Amount (${currency})`,
      name: <p style={{ paddingLeft: "28px", fontSize: "12px" }}>{`Amount (${currency})`}</p>,
      // selector: row => row.finalAmount,
      selector: row => (
        <span style={{ fontSize: "12px" }}>{formatCurrencyAUD(row.finalAmount)}</span>
      ),
      sortable: true,
      sortField: 'finalAmount',
      center: "true",
    },
    {
      // name: "Action(s)",
      name: <p style={{ fontSize: '12px' }}>Action(s)</p>,
      // selector: row => row.actions,
      selector: row => (
        <span style={{ fontSize: "12px" }}>{row.actions}</span>
      ),
      center: "true",
      cell: row => <IconMenu size="small" row={
        <>
          {/* <Grid container justifyContent={"center"} mr={2} spacing={3.2} mt={-6.2}> */}
          <Grid style={{ width: "100%" }} item>
            <Link to={`/contacts/editContact/${row.actions._id}`} disabled={!screenAccess}>
              <p style={darkMode ? { color: "white" } : { color: "black" }}>
                <TimelineItem color="success"
                  //  icon="edit"
                  icon={<EditIcon className="actionicon" disabled={!screenAccess} />}
                  title="Edit" disabled={SCREEN_RIGHT === "View Only"} />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Edit</p>
            </Link>
          </Grid>

          <Grid style={{ width: "100%" }} item >
            <p onClick={() => { row.contactStatus === "Active" && handleMergeContactIcon(row); }} style={darkMode ? { color: "white" } : { color: "black" }} disabled={!screenAccess}>
              <TimelineItem
                color={row.contactStatus === "Active" ? "primary" : "grey"}
                // icon="mergeIcon"
                // icon="mergeIcon"
                icon={<MergeTypeIcon className="actionicon" />}
                onClick={() => { row.contactStatus === "Active" && handleMergeContactIcon(row); }}
                title="Merge" disabled={!screenAccess}
              // disabled={SCREEN_RIGHT === "View Only"}
              />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Merge</p>
          </Grid>
          <Grid style={{ width: "100%" }} item >
            <p onClick={() => handleDeleteDialogeClick(row.actions._id)} style={darkMode ? { color: "white" } : { color: "black" }} disabled={!screenAccess}>
              <TimelineItem
                color="error"
                // icon="delete"
                icon={<DeleteIcon className="actionicon" />}
                onClick={() => handleDeleteDialogeClick(row.actions._id)}
                title="Delete"
                disabled={!screenAccess}
              // disabled={SCREEN_RIGHT === "View Only"}
              />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Delete</p>
          </Grid>
          {/* </Grid> */}
        </>
      } />,
    },
  ];

  const handleActivityStatement = async () => {

    if (values.themeID && values.themeID !== "add_new") {
      // });
      if (statementsValues.contactIDs.length > 0) {
        const { startDate, endDate } = getSentDate(values);

        // let fileName = await getDownloadFileName(statementsValues.from === startDate, statementsValues.to === endDate);
        let fileName = await getDownloadFileName(startDate, endDate);
        getCustomerActivityStatements({
          ...statementsValues,
          from: startDate,
          to: endDate,
        }, (dataRes) => {
          if (dataRes.Result_Status) {
            if (statementsValues.type === "Print") {

              const pdfContent = dataRes.Result_Output;
              const binaryPdfData = atob(pdfContent);
              const arrayBuffer = new ArrayBuffer(binaryPdfData.length);
              const uint8Array = new Uint8Array(arrayBuffer);
              for (let i = 0; i < binaryPdfData.length; i++) {
                uint8Array[i] = binaryPdfData.charCodeAt(i);
              }
              const blob = new Blob([arrayBuffer], { type: 'application/pdf' });

              const url = URL.createObjectURL(blob);
              window.open(url, '_blank');

              const link = document.createElement('a');
              link.href = url;
              link.download = fileName;
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);

              showResMsg(`File downloaded successfully, Please click to view.`, 2000, true);
              // ShowSwalWithButtons(
              //   '', `Would you like to download the Activity Statement?`, 'question', darkMode,
              //   () => {
              //   }
              // );
              // Swal.fire({
              //   text: `Would you like to download the Activity Statement?`,
              //   icon: "question",
              //   showDenyButton: true,
              //   confirmButtonText: "Yes",
              //   denyButtonText: `No`,
              //   customClass: {
              //     confirmButton: 'confirm-button',
              //     denyButton: 'deny-button'
              //   }
              // }).then((result) => {
              //   if (result.isConfirmed) {
              //     document.body.appendChild(link);
              //     link.click();
              //     document.body.removeChild(link);
              //   }
            } else {
              showResMsg(dataRes.Result_Message, 2000, dataRes.Result_Status);
            }

          } else {
            showResMsg(dataRes.Result_Message, 2000, false);
          }
        }, dispatch);
      } else {
        showResMsg(genericMessage.selectCustomer, 2000, false);
      }
    } else {
      showResMsg(genericMessage.noSelectedTheme, 2000, false);
    }
  }

  const handleStatement = async (type) => {

    // if (values.themeID && values.themeID !== "add_new") {
    if (statementsValues.contactIDs.length > 0) {
      ShowSwalWithButtons(
        'Are you sure?', `Would you like to ${type === "Print" ? "View" : "share"} the Activity Statement ?`, 'warning', darkMode,
        () => {
          statementsValues.type = type;
          handleActivityStatement();
        }
      );


    } else {
      showResMsg(genericMessage.selectCustomer, 2000, false);
    }
    // } else {
    //   showResMsg(genericMessage.noSelectedTheme, 2000, false);
    // }
  };

  const handlePrintStatement = async () => {
    await handleStatement("Print");
    setShowStatementModal(false);
  };

  const handleEmailStatement = async () => {
    await handleStatement("Email");
    setShowStatementModal(false);
  };

  const handleConfigThemeChange = (name) => (e) => {
    if (name === "themeID" && e.target.value === "add_new") {
      navigate("/invoicePdfFormat/addInvoicePdfFormat?new=contacts");
    } else {
      setValues({ ...values, themeID: e.target.value })
    }
  }
  const handleMergeContactIcon = async (value) => {
    try {
      const filterList = customerContact?.filter(contact => contact.contactType === value.contactType && contact._id !== value._id && contact.contactStatus === "Active")
      if (filterList && filterList.length > 0) {
        setMergeContactValues({ ...mergeContactValues, merge_ID: value._id, merge_Contact: value.name, contactType: value.contactType })
        setContactForMerge(filterList);
        setSelectedContactName(value.name);
        setShowMergeModal(true);
      } else {
        showResMsg(`No Customer available for Merge.`, 2000, false)
      }

    } catch (error) {
      console.log("Error while Merge Contact", error.message);
    }

  }

  const handleSubmitMerge = async () => {

    MergeContactTransaction(mergeContactValues, (data) => {
      showResMsg(data.Result_Message, 2000, data.Result_Status);
      setShowMergeModal(false);
      fetchContacts();
      setMergeContactValues({ ...mergeContactValues, merge_Contact: "", merge_ID: "", mergeWith_ContactName: "", mergeWith_ID: "" });
    }, dispatch)
  }

  const handleCloseMergeModal = async () => {
    setMergeContactValues({ ...mergeContactValues, merge_Contact: "", merge_ID: "", mergeWith_ContactName: "", mergeWith_ID: "" })
    setShowMergeModal(false);
  }

  const handleClose = (event, reason) => {
    // Prevent closing the modal when clicking the backdrop
    if (reason && reason === "backdropClick") {
      return;
    }
    setShowMergeModal(false);
  };





  const { tableBorder } = getColorMappings(sidenavColor);


  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: 350,
        overflowY: 'scroll',

      },
    },
  };
  const handleSearchInputValue = useCallback((searchInput) => {
    setValues(prevValues => ({ ...prevValues, filterValues: searchInput }));
  }, []);

  const getSearchResult = useCallback(() => {
    fetchContacts();
  }, [values.filterValues]);



  useEffect(() => {
    // eslint-disable-next-line eqeqeq
    if (values.filterValues.length == "") {
      getSearchResult();

    }
  }, [values.filterValues]);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <div style={{ marginTop: '20px' }}>
        <Card color="primary">
          <PageTitle screenName="Contacts" />
          <Grid container mt={2.2} gap={2} style={{ display: "flex", justifyContent: "end", marginRight: "40px" }}>

            {/* {showStatementBtn && values.duration === 'custom' && (
              <Grid container lg={3} xs={6} spacing={2} >
                <Grid item xs={6} style={{ height: '38.11px' }}>
                  <PickDate
                    // selected={new Date(statementsValues.from)}
                    // onChange={handleDateChange('from')}
                    selected={values.fromDate}
                    onChange={handleDateChange('fromDate')}
                    label="From"
                    variant="outlined"
                    style={{ height: "38.11px" }}
                    InputLabelProps={{ shrink: true }}
                    maxDate={new Date(new Date().setDate(new Date().getDate() - 1))}
                  />
                </Grid>
                <Grid item xs={6} style={{ height: '38.11px' }}>
                  <PickDate
                    // selected={new Date(statementsValues.to)}
                    selected={values.toDate}
                    onChange={handleDateChange('toDate')}
                    label="To"
                    variant="outlined"
                    style={{ height: "38.11px" }}
                    InputLabelProps={{ shrink: true }}
                    maxDate={new Date()}
                  />
                </Grid>
              </Grid>
            )}
            {showStatementBtn &&
              <Grid lg={1.5} xs={6} >
                <FormControl fullWidth >
                  <InputLabel id="duration-label">Duration</InputLabel>
                  <Select
                    labelId="duration-label"
                    id="duration-select"
                    style={{ height: "38.11px" }}
                    value={values.duration}
                    onChange={(e) => setValues({ ...values, duration: e.target.value })}
                    label="Duration"
                  >
                    <MenuItem value="today">Today</MenuItem>
                    <MenuItem value="lastWeek">Last 7 Days</MenuItem>
                    <MenuItem value="lastMonth">Last 30 Days</MenuItem>
                    <MenuItem value="lastYear">Last 12 months</MenuItem>
                    <MenuItem value="custom">Custom Date</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
            }
              */}
            <Grid lg={1.5} xs={6} >
              <FormControl fullWidth>
                <InputLabel id="Status">Filter By Status</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  style={{ height: "38.11px" }}
                  label="Filter By Status"
                  value={values.contactStatus}
                  onChange={(e) => setValues({ ...values, contactStatus: e.target.value })}
                >
                  <MenuItem value="All">All</MenuItem>
                  <MenuItem value="Active">Active</MenuItem>
                  <MenuItem value="Inactive">Inactive</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            {!showStatementBtn &&
              <Grid lg={2} xs={6} >
                <FormControl fullWidth>
                  <InputLabel id="Status">Filter By Contact Type</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    style={{ height: "38.11px" }}
                    label="Filter By Contact Type"
                    value={values.contactType}
                    onChange={(e) => setValues({ ...values, contactType: e.target.value })}
                  >
                    <MenuItem value="All">All</MenuItem>
                    <MenuItem value="Customer">Customer</MenuItem>
                    <MenuItem value="Supplier">Supplier</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
            }
            <Grid lg={2.5} xs={6}>
              {/* <SearchField
                tableBorder={tableBorder}
                searchValue={values.filterValues}
                setSearchValue={handleSearchInputValue}
                getSearchResult={getSearchResult}
              /> */}
              <TextField
                type="text"
                variant="outlined"
                fullWidth
                className="searchButton"
                placeholder="Search..."
                label="Search Filter"
                value={values.filterValues}
                onChange={handleSearchFilter}
                onKeyUp={(e) => {
                  if (e.key === "Enter") fetchContacts();
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment  >
                      <Button style={{ borderRadius: "0px 0.5rem  0.5rem 0px", boxShadow: "none", background: barColor }} variant="contained" onClick={fetchContacts}>
                        <GridSearchIcon color="white" />
                      </Button>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>

            {!showStatementBtn &&
              <Grid item xs={6} spacing={2} lg={1} >
                {screenAccess ?
                  <Link to={"/contacts/addContact"} >
                    <MDButton
                      className={"btn-block center-container-btn btn-success btn-back rightSpace btn-Height"}
                      variant="contained"
                      color="success"
                      fullWidth

                      style={{ height: "38.11px" }}
                    >
                      Add New
                    </MDButton>
                  </Link>
                  :
                  <MDButton
                    className={"btn-block center-container-btn btn-success btn-back rightSpace btn-Height"}
                    variant="contained"
                    color="secondary"
                    fullWidth
                    style={{ height: "38.11px" }}
                  >
                    Add New
                  </MDButton>
                }
              </Grid>
            }
            {showStatementBtn &&
              // <Grid container mt={1.6} gap={2} style={{ display: "flex", justifyContent: "end", marginRight: "40px" }}>
              <Grid item xs={6} lg={1} spacing={2} >
                <MDButton
                  className={"btn-block center-container-btn btn-success btn-back rightSpace btn-Height"}
                  variant="contained"
                  color="success"
                  style={{ height: "38.11px" }}
                  fullWidth
                  onClick={handleCustomerStatement}
                  disabled={!statementsValues.contactIDs || statementsValues.contactIDs.length === 0}
                >
                  View/Email Statement
                  {/* <AttachEmailTwoToneIcon className="icon-spacing" /> */}
                </MDButton>
              </Grid>
              // </Grid>
            }
            <Grid item xs={6} spacing={2} lg={1} mr={2} >
              {screenAccess ?
                <MDButton
                  className={"btn-block center-container-btn btn-warning btn-back rightSpace btn-Height"}
                  color={"warning"}
                  variant="contained"
                  fullWidth
                  style={{ height: "38.11px" }}
                  onClick={() => {
                    setStatementValues({ ...statementsValues, contactIDs: [] });
                    setShowStatementBtn(!showStatementBtn);
                    setToggleCleared(prev => !prev);
                  }}

                >
                  {showStatementBtn ? "Hide Statement" : "Show Statement"}

                </MDButton>
                :
                <MDButton
                  className={"btn-block center-container-btn btn-warning btn-back rightSpace btn-Height"}
                  color={"secondary"}
                  variant="contained"
                  fullWidth
                  style={{ height: "38.11px" }}

                >
                  {showStatementBtn ? "Hide Statement" : "Show Statement"}

                </MDButton>
              }
            </Grid>
          </Grid>


          {/* {showStatementBtn &&
            <Grid container mt={1.6} gap={2} style={{ display: "flex", justifyContent: "end", marginRight: "40px" }}> */}
          {/* <Grid item xs={6} lg={3}>
                <FormControl fullWidth>
                  <InputLabel id="Theme">Theme (Used as Invoice Format)</InputLabel>
                  <Select
                    labelId="theme-label-Dropdown"
                    id="theme-label-Dropdown"
                    style={{ height: "38.11px" }}
                    label="Theme (Used as Invoice Format)"
                    value={values.themeID}
                    onChange={handleConfigThemeChange("themeID")}
                    MenuProps={MenuProps}
                  >
                    <MenuItem style={{ color: tableBorder, fontWeight: "bold" }} value="add_new">Add New Theme</MenuItem>
                    {themeName}
                  </Select>
                </FormControl>
              </Grid> */}
          {/* // KARAN CODE */}
          {/* <Grid item xs={6} lg={1.4}>
                <PickDate
                  selected={new Date(statementsValues.from)}
                  onChange={handleDateChange('from')}
                  label="From"
                  variant="outlined"
                  InputLabelProps={{ shrink: true }}
                  maxDate={new Date(new Date().setDate(new Date().getDate() - 1))}
                />
              </Grid>
              <Grid item xs={6} lg={1.4}>
                <PickDate
                  selected={new Date(statementsValues.to)}
                  onChange={handleDateChange('to')}
                  label="To"
                  variant="outlined"
                  InputLabelProps={{ shrink: true }}
                  maxDate={new Date()}
                />
              </Grid> */}
          {/* <Grid item xs={6} spacing={2} lg={1}  >
                <MDButton
                  className={"btn-block center-container-btn btn-warning btn-back rightSpace btn-Height"}
                  color={"warning"}
                  variant="contained"
                  fullWidth
                  style={{ height: "38.11px" }}
                  onClick={handlePrintStatement}
                >
                  View  <PictureAsPdfIcon className="icon-spacing" />
                </MDButton>
              </Grid>
              <Grid item xs={6} spacing={2} lg={1} mr={2} >
                <MDButton
                  className={"btn-block center-container-btn btn-success btn-back rightSpace btn-Height"}
                  variant="contained"
                  color="success"
                  style={{ height: "38.11px" }}
                  fullWidth
                  onClick={handleEmailStatement}
                >
                  Email <AttachEmailTwoToneIcon className="icon-spacing" />
                </MDButton>
              </Grid> */}
          {/* <Grid item xs={6} spacing={2} lg={1} mr={2} >
                <MDButton
                  className={"btn-block center-container-btn btn-success btn-back rightSpace btn-Height"}
                  variant="contained"
                  color="success"
                  style={{ height: "38.11px" }}
                  fullWidth
                  onClick={handleCustomerStatement}
                >
                  View/Email Statement
                  {/* <AttachEmailTwoToneIcon className="icon-spacing" /> */}
          {/* </MDButton>
              </Grid>
            </Grid>
          }  */}
          {/* <CardContent> */}

          <BTable
            columns={columns}
            data={rows}
            selectableRows={showStatementBtn}
            onSelectedRowsChange={handleRowSelected}
            selectableRowDisabled={rowDisabledCriteria}
            sortingType={handleSort}
            sortServer
            pagination
            paginationServer
            paginationTotalRows={totalRows}
            onChangeRowsPerPage={handlePerRowsChange}
            onChangePage={handlePageChange}
            clearSelectedRows={toggleCleared}
            fixedHeaderScrollHeight="410px"
            fixedHeader={true}
          />
          {/* </CardContent> */}
        </Card>
      </div >

      <DeleteModal
        open={deleteDialogeFlag}
        handleDelete={handleDelete}
        handleCancel={handleCancel("handleCancel")}
        closeModalClick={handleCancel("closeModalClick")}
        message={deleteHeading}
      />

      <Modal
        open={showMergeModal}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        disableEscapeKeyDown
      >
        <Card className={darkMode ? "dark-mode" : "light-mode"} sx={mergeModalstyle}>
          <Box>
            <h4 style={{ fontSize: "22px" }} id="modal-title">Merge transaction history</h4>
            <Typography id="modal-modal-title" variant="h6" component="h2" style={{ fontSize: "40px", textAlign: "center" }}>

            </Typography>
            <Typography className={darkMode ? "dark-mode" : "light-mode"} id="modal-modal-title" variant="h6" component="h3" style={{ fontSize: "16px", color: "black", fontWeight: "normal" }}>
              <b style={{ fontWeight: "bolder" }}>{mergeContactValues?.merge_Contact}</b> ({mergeContactValues?.contactType}) will be <b style={{ color: "red", fontWeight: "bolder" }}>deleted</b> and their transaction history will be merged with the contact below
            </Typography>
            <MDTypography
              variant="button"
              fontWeight="regular"
              color="info"
              sx={{ cursor: "default", userSelect: "none", ml: -1, paddingBottom: '6px' }}
            >
              <b > &nbsp;&nbsp;Contact to merge with {mergeContactValues?.contactType}</b>
            </MDTypography>

            <FormControl fullWidth style={{ marginTop: '10px' }}>

              <Autocomplete
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                color="info"
                options={contactForMerge?.length > 0 && contactForMerge.map(contact => ({
                  label: contact.name,
                  id: contact._id
                }))}
                onChange={handleAutoComplete("mergeWith_ContactName")}
                value={mergeContactValues.mergeWith_ContactName}
                ListboxProps={{
                  style: { maxHeight: 35 * 8 },
                }}
                renderInput={(params) =>
                  <TextField {...params}
                    label="Search for a contact"
                    placeholder="Search for a contact"
                    sx={{ height: 44.44, paddingBottom: '6px' }}
                    size="medium" />}
              />

            </FormControl>
            <Grid container id="modal-modal-description" sx={{ mt: 2, justifyContent: "center" }}>
              <MDButton color="warning" onClick={handleCloseMergeModal} className="modalButton">
                Cancel
              </MDButton>
              &nbsp; &nbsp;
              <MDButton color="error" className="modalButton"
                onClick={handleSubmitMerge}
              >
                Merge
              </MDButton>
            </Grid>
          </Box>
        </Card>
      </Modal>


      <Modal
        open={showStatementModal}
        onClose={handleCloseModel}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        disableEscapeKeyDown
      >
        <Card className={darkMode ? "dark-mode" : "light-mode"} sx={{ padding: 2, width: 400, margin: 'auto', marginTop: '15%' }}>
          <Box>
            <Typography id="modal-title" variant="h5" component="h2" align="center">
              Select Duration
            </Typography>

            <Grid item lg={4} md={4} xs={12} >
              <FormControl fullWidth style={{ marginTop: '10px' }}>
                <InputLabel id="duration-label">Duration</InputLabel>
                <Select
                  labelId="duration-label"
                  id="duration-select"
                  style={{ height: "38.11px" }}
                  value={values.duration}
                  onChange={(e) => setValues({ ...values, duration: e.target.value })}
                  label="Duration"
                >
                  <MenuItem value="today">Today</MenuItem>
                  <MenuItem value="lastWeek">Last 7 Days</MenuItem>
                  <MenuItem value="lastMonth">Last 30 Days</MenuItem>
                  <MenuItem value="lastYear">Last 12 months</MenuItem>
                  <MenuItem value="custom">Custom Date</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            {values.duration === 'custom' && (
              <Grid container spacing={2} sx={{ mt: 1 }}>
                <Grid item xs={6}>
                  <PickDate
                    // selected={new Date(statementsValues.from)}
                    // onChange={handleDateChange('from')}
                    selected={values.fromDate}
                    onChange={handleDateChange('fromDate')}
                    label="From"
                    variant="outlined"
                    InputLabelProps={{ shrink: true }}
                    maxDate={new Date(new Date().setDate(new Date().getDate() - 1))}
                  />
                </Grid>
                <Grid item xs={6}>
                  <PickDate
                    // selected={new Date(statementsValues.to)}
                    selected={values.toDate}
                    onChange={handleDateChange('toDate')}
                    label="To"
                    variant="outlined"
                    InputLabelProps={{ shrink: true }}
                    maxDate={new Date()}
                  />
                </Grid>
              </Grid>
            )}

            <Grid container sx={{ mt: 2, px: 6, justifyContent: "space-between" }}>
              <MDButton color="success"
                // onClick={() => handleSubmit('view')}
                onClick={handlePrintStatement}
              >
                View
              </MDButton>
              <MDButton color="error"
                // onClick={() => handleSubmit('email')}
                onClick={handleEmailStatement}
              >
                Email
              </MDButton>
              <MDButton color="warning" onClick={handleCloseModel}>
                Cancel
              </MDButton>
            </Grid>
          </Box>
        </Card>
      </Modal>

    </DashboardLayout >
  );

}

export default Contacts;
